<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
            <div class="newtext">新手指引</div>
            <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
            <img src="../../../assets/images/pop/tjlb/tjlb1.jpg" class="steps step1" v-if="status==1">
            <img src="../../../assets/images/pop/tjlb/tjlb2.jpg" class="steps step2" v-if="status==2" >
            <div class="stepbtn" @click="nextStep(status)">
                {{status==1?"下一步":status==2?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked">下次不再提示</el-checkbox>
            </div>
        </div>
        <!--        <breadcrumb :routerList="[{to:'/pricenewN',title:'特价管理'},{title:'特价列表'}]"/>-->
        <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox zhi">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">

                        <div class="h-thirdColumn w-newColumn">

                            <el-form-item label="大区" prop="daquCode">
                                <brselect category="daqu" :v="formInline.daquCode" :showcode="true"
                                          v-model="formInline.daquCode" clearable></brselect>
                            </el-form-item>

                            <el-form-item label="区域" prop="soldToAreaCode">
                                <brselect category="YLRegion" :v="formInline.soldToAreaCode" v-model="formInline.soldToAreaCode"
                                          :clearable="true"
                                          :multiple="true"
                                          style="width:100%"/>
                            </el-form-item>

                            <el-form-item label="特价类型" prop="category">
                                <brselect category="category_tejia" :v="formInline.category" :showcode="true"
                                          v-model="formInline.category" clearable></brselect>
                            </el-form-item>
                        </div>
                        <el-collapse-transition>
                            <div v-show="isScreen">
                                <div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="特价版本号" prop="category">
                                        <el-input v-model="formInline.specialCode" placeholder="请输入"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-collapse-transition>
                    </el-form>
                    <div class="l-screenBox">
                        <div class="l-screen" @click="collapseChange">
                            <img :src="isScreen?closeScreen:drawScreen" alt="">
                            <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
                        </div>
                        <div class="l-retrieval">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-row T-jia">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData2"
                            border
                            stripe
                            max-height="450"
                    >
                        <el-table-column
                                type="selection"
                                width="45"
                                label="全选"
                                fixed
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
                                width="40"
                                fixed
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="specialCode"
                                label="特价版本号"
                                :show-overflow-tooltip="true"
                                width="150">
                            <template scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.specialCode}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="category"
                                label="特价类型"
                                :show-overflow-tooltip="true"
                                width="100"
                        >
                            <template slot-scope="scope" >
                                {{scope.row.category|dictname('category_tejia')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="status"
                                label="特价状态"
                                :show-overflow-tooltip="true"
                                width="100"
                        >
                            <template slot-scope="scope" >
                                {{scope.row.status|dictname('tejiazhuangtai')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="startdate"
                                label="开始时间"
                                :show-overflow-tooltip="true"
                                :formatter="formatDate"
                                min-width="120">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.startdate}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="validity"
                                label="截止时间"
                                :show-overflow-tooltip="true"
                                :formatter="formatDate"
                                min-width="120">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.validity}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="customerChannelCode"
                                label="渠道"
                                :show-overflow-tooltip="true"
                                width="90"
                        >
                            <template slot-scope="scope" >
                                {{scope.row.customerChannelCode|dictname('sales_region')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="soldToName"
                                label="用户名称"
                                :show-overflow-tooltip="true"
                                width="150"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.soldToName}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="daquName"
                                label="大区"
                                :show-overflow-tooltip="true"
                                width="90"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.daquName}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="soldToAreaName"
                                label="区域"
                                :show-overflow-tooltip="true"
                                width="90"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.soldToAreaName}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="projectName"
                                label="项目名称"
                                :show-overflow-tooltip="true"
                                width="120"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.projectName}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="proModelName"
                                label="产品大类"
                                :show-overflow-tooltip="true"
                                width="120"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.proModelName}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="materialName"
                                label="产品型号"
                                :show-overflow-tooltip="true"
                                width="150"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.materialName}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="materialCode"
                                label="产品编码"
                                :show-overflow-tooltip="true"
                                width="120"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.materialCode}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="proBenchmarkPrice"
                                label="基准价"
                                :show-overflow-tooltip="true"
                                width="90"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.proBenchmarkPrice}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="specialPrice"
                                label="申请特价"
                                :show-overflow-tooltip="true"
                                width="90"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.specialPrice}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="proDiscount"
                                label="折扣率"
                                :show-overflow-tooltip="true"
                                width="80"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.proDiscount}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="advancePrice"
                                label="占用资源池金额"
                                :show-overflow-tooltip="true"
                                width="120"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.advancePrice}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="advancePriceNotax"
                                label="占用资源池不含税金额"
                                :show-overflow-tooltip="true"
                                width="120"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.advancePriceNotax}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="occupyAreaPrice"
                                label="占用区域金额"
                                :show-overflow-tooltip="true"
                                width="120"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.occupyAreaPrice}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="occupyPtPrice"
                                label="占用平台金额"
                                :show-overflow-tooltip="true"
                                width="120"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.occupyPtPrice}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="avaiNumber"
                                label="剩余数量"
                                :show-overflow-tooltip="true"
                                width="100"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.avaiNumber}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="totalNumber"
                                label="申请数量"
                                :show-overflow-tooltip="true"
                                width="100"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.totalNumber}}
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                                prop="cuname"
                                label="创建人"
                                :show-overflow-tooltip="true"
                                width="80"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="cucode"
                                label="创建人编码"
                                :show-overflow-tooltip="true"
                                width="80"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="cdate"
                                label="创建时间"
                                :formatter="formatDate"
                                :show-overflow-tooltip="true"
                                width="100"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="tejiashuoming"
                                label="特价立项说明"
                                :show-overflow-tooltip="true"
                                width区域="120"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.tejiashuoming}}
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="h-tableB h-mrt30" style="padding-right: 0.12rem;">
                <div class="h-tableBL">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
                </div>
                <div class="h-pagination2 h-pageCenter">
                    <pagination :page="formInline" @query="query"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
    import updownfile from '../../../utils/updownfile'
    export default {
        components: {
            uploaddownexcel,
            updownfile,
        },
        data() {
            return {
                closeScreen:require("@/assets/images/pimg/closeallic.png"),
                drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                tableData2:[],
                formInline: {
                    field:null,//领域
                    daquCode:null,//大区
                    category:null,//特价类型
                    specialCode:null,//特价版本号
                    soldToAreaCode:null,//区域
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                up:{
                    id: null,
                    field: null,
                    specialCategory: null,
                    year: null,
                    month: null,
                    importMoney: null,
                },
                uploaddownexcelflag:false,
                showOrhide:false,
                updateVisDialogFlag:false,
                uptitleDig: null,
                isScreen: false,
            }
        },
        //加载页面默认执行
        created() {
            this.query();
        },
        mounted() {

        },
        methods: {
            /*// 展开折叠
            collapseChange(){
                this.isScreen = !this.isScreen;
            },*/
            showzhezhao(){
                ss.salesList.toshow(this.toshow).then(rd => {
                    console.log(rd)
                    if(rd == false){
                        this.showOrhide = false;
                    }else{
                        this.showOrhide = true;
                    }
                })
            },
            //重置
            resetData(){
                this.formInline.category = null;
                this.formInline.field = null;
                this.formInline.daquCode = null;
                this.formInline.soldToAreaCode = null;
                this.formInline.specialCode = null;
            },
            //检索
            query(){
                ss.resourcePool.selectDetailPage(this.formInline).then(rd => {
                    this.tableData2 = rd.records;
                    this.formInline.total = rd.total;
                })
            },
            //明细导出
            exportExcel() {
                updownfile.down("/api/swyl/v1/poolDetail/downloadExcel",this.formInline,"post",'data');
            },
            dateFormatter(v){
                var now = new Date(v);
                var year=now.getFullYear();
                var month = now.getMonth()+1 < 10?'0'+(now.getMonth()+1) : now.getMonth()+1;
                var alldata2 =  year+"-"+month;
                return alldata2;
            },
            formatDate(row, column) {
                // 获取单元格数据
                let data = row[column.property]
                if(data == null || data == '') {
                    return null
                }
                let dt = new Date(data)
                return this.$util.riQi3(dt);
            },
            // 展开折叠
            collapseChange(){
                this.isScreen = !this.isScreen;
            },
            //检索
            handleFilter() {
                this.formInline.pageNo = 1;
                this.query();
            },
            //获取表头数据
        }
    }
</script>
<style scoped>
    .selectorBox {
        width: 100%;
        padding: 0.54rem 0.28rem 0 0.25rem;
    }
    .selectorBox .text {
        margin-left: 0.38rem;
        font-size: 0.18rem;
        color: #4a4a4a;
        position: relative;
    }
    .selectorBox .text::before {
        content: "*";
        position: absolute;
        top: 0;
        left: -7px;
        color: red;
        font-size: 0.2rem;
    }
    .selectorBox .selector {
        margin-left: 0.38rem;
        margin-top: 20px;
        display: flex;
    }
    .selectorBox .selector .button {
        width: 65px;
        padding: 10px;
        color: #b7b7b7;
        border: 1px solid #dcdfe1;
        text-align: center;
        line-height: 20px;
        cursor: pointer;
    }
    .selectorBox .selector .button.active {
        color: #fff;
        background: #238cfd;
        border: 1px solid #238cfd;
    }
    .T-jia .h-btn.el-button.h-tableLink{
        padding: 0 0.05rem;
    }
    #xcv {
        padding: 0.14rem 0.2rem;
        font-size: 0.18rem;
        color: #fff;
        letter-spacing: 0.02rem;
        border: 1px solid #24b5b8;
        background: #24b5b8;
        border-radius: 0.04rem;
        line-height: 0.18rem;
    }
</style>
<style>
    .X-la .h-formbLine .el-form-item__content .el-select{
        width: 100%!important;
    }
    .zhi .el-date-editor .el-range-separator{
        width:13%;
        margin-bottom:7px;
    }
    .selectorBox .el-input-group__append {
        background: #238cfd;
        color: #fff
    }
    .selectorBox .el-upload-list {
        display: none;
    }

</style>
<style scoped lang="scss">
    .bottomTip{
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
        z-index: 999999;
    }
    .newtext{
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top:0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow:1px 1px 4px #2785E7;
        z-index: 2;
    }
    .leaderBox{
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;
        .leaderbg{
            width: 100%;
            height: 100%;

        }
        .steps{
            position: absolute;
            z-index: 1;

        }
        .step1{
            top: 0;
            left: 0;

        }
        .step2{
            top: 0;
            right: 0;
        }
        .stepbtn{
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0,0,0,0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.75rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }
        .closeIt{
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
            z-index: 2;
        }
    }
</style>
